class TabChange {
  constructor() {
    this.target = document.querySelectorAll('[data-tab-link]')
    this.targetDom = document.querySelectorAll('[data-tab-list]')
    this.targetDom.forEach(value => {
      Array.from(value.children).forEach(childValue => {
        childValue.style.visibility = 'hidden'
      })
    })
    document.querySelector('.c-tab__list li:first-child').style.visibility = 'visible'
    window.addEventListener('load', this.doClick.bind(this))
  }

  doClick() {
    this.target.forEach((tabValue, targetIndex) => {
      tabValue.querySelectorAll('li').forEach((tabChildValue,tabValueIndex) => {
        tabChildValue.addEventListener('click', () => {
          tabValue.querySelectorAll('li').forEach(value => {
            value.classList.remove('active')
          })
          Array.from(this.targetDom[targetIndex].children).forEach(value => {
            value.style.visibility = 'hidden'
          })
          tabValue.children[tabValueIndex].classList.add('active')
          this.targetDom[targetIndex].children[tabValueIndex].style.visibility = 'visible'
        })
      })
    })
  }
}

// クーポンコードコピー
const copyFunc = () => {
  const target = document.querySelectorAll('[data-copy]')
  Array.from(target).forEach(value => {
    value.addEventListener('click', () => {
      navigator.clipboard.writeText(value.dataset.copy);
      console.log(value.nextElementSibling);
      value.nextElementSibling.classList.add('show')
      setTimeout(() => {
        value.nextElementSibling.classList.remove('show')
      }, 2000)
    })
  })
}

//read more
const readMore = (clsTxt, clsBtn) => {
  const targetTxt = document.querySelectorAll(`.${clsTxt}`)
  const openHeight = []
  const closeHeight = []
  Array.from(targetTxt).forEach(value => {
    openHeight.push(value.clientHeight)
    value.classList.add('is-hide')
    closeHeight.push(value.clientHeight)
  })
  const targetBtn = document.querySelectorAll(`.${clsBtn}`)

  Array.from(targetBtn).forEach((value, index) => {
    value.addEventListener('click', () => {

      if(value.classList.contains('is-show')) {
        value.classList.remove('is-show')
        value.previousElementSibling.classList.remove('is-show')
        value.classList.add('is-hide')
        value.innerText = 'Read more +' 
        value.previousElementSibling.classList.add('is-hide')
        value.previousElementSibling.style.height = `${closeHeight[index]}px`
      } else {
        value.classList.remove('is-hide')
        value.previousElementSibling.classList.remove('is-hide')
        value.classList.add('is-show')
        value.innerText = 'Close -'
        value.previousElementSibling.classList.add('is-show')
        value.previousElementSibling.style.height = `${openHeight[index]}px`
      }
    })
  })
}

//wechat
const wechat = () => {
  const popup = document.querySelector('.p-sns__popup')

  document.addEventListener('click', (e) => {
    if(!e.target.closest('.p-sns__wechat')) {
      //ここに外側をクリックしたときの処理
      popup.classList.remove('show')
    } else {
      //ここに内側をクリックしたときの処理
      popup.classList.add('show')
    }
  })
}

const glide = () => {
  document.querySelectorAll('[data-tab-list] .glide').forEach(value => {
    new Glide(value, {
      type: 'carousel',
      startAt: '0',
      perView: 1,
      focusAt: 'center',
      gap: 0,
      // autoplay: 4000,
      breakpoints: {
        768: {
          perView: 1,
          focusAt: 'center',
        },
      }
    }).mount();
  })
}

const calcHeight = () => {
  document.querySelectorAll('.c-tab__list').forEach(value => {
    const heightArray = Array.from(value.children).map(childValue => childValue.clientHeight)
    const tabHeight = heightArray.reduce((a, b) => {return Math.max(a, b)});
    const maxHeightindex = heightArray.indexOf(tabHeight)
    value.style.height = `${tabHeight}px`
    Array.from(value.children).forEach((value, index) => {
      if(index != maxHeightindex) {
        value.style.position = 'absolute'
      } else {
        value.style.position = 'static'
      }
    })
  })
}

const TabChangeFunc = new TabChange()
window.addEventListener('load', () => {
  glide()
  TabChangeFunc
  readMore('js-accordion-txt', 'js-accordion-btn')

  window.matchMedia('(min-width: 768px)').addEventListener("change", spFunc);
  spFunc(window.matchMedia('(min-width: 768px)'));
  function spFunc(event) {
    if(!event.matches) {
      readMore('js-accordion-txt_sp', 'js-accordion-btn_sp')
    }
  }
  copyFunc()
  wechat()
  calcHeight()
  window.addEventListener('resize', () => {
    calcHeight()
  })
})